import { AuthService } from './../../../../../shared/services/auth.service';
import { Component, Input, OnInit } from '@angular/core';
import { ProjectNode } from 'src/app/shared/models/projectNode';
import { Client } from 'src/app/shared/models/client';
import { ProjectModel } from 'src/app/shared/models/projectModel';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-project-tree-comparison',
  templateUrl: './project-tree-comparison.component.html',
  styleUrls: ['./project-tree-comparison.component.scss']
})
export class ProjectTreeComparisonComponent implements OnInit {
  client?: Client;
  selectedModels: ProjectModel[] = [];

  constructor(private authService: AuthService) {
    this.client = authService.getClientDataStructure();
  }

  ngOnInit() {
    // Initialize component
  }

  hasModels = (_: number, node: ProjectNode) => !!node.models && node.models.length > 0;

  // Check if all models under a node are selected
  areAllModelsSelected(node: ProjectNode): boolean {
    const allModels = this.getAllModels(node);
    return allModels.length > 0 && allModels.every(model => this.isModelSelected(model));
  }

  // Get all models under a node recursively
  private getAllModels(node: ProjectNode): ProjectModel[] {
    let models: ProjectModel[] = [];
    if (node.models) {
      models = models.concat(node.models);
    }
    if (node.nodes) {
      node.nodes.forEach(childNode => {
        models = models.concat(this.getAllModels(childNode));
      });
    }
    return models;
  }

  // Toggle selection of a node (select/deselect all models under it)
  toggleNodeSelection(node: ProjectNode, event: MatCheckboxChange) {
    this.toggleNodeModels(node, event.checked);
  }

  private toggleNodeModels(node: ProjectNode, checked: boolean) {
    if (node.models) {
      node.models.forEach(model => {
        this.toggleModelSelectionByValue(model, checked);
      });
    }
    if (node.nodes) {
      node.nodes.forEach(childNode => {
        this.toggleNodeModels(childNode, checked);
      });
    }
  }

  // Toggle selection of a single model
  toggleModelSelection(model: ProjectModel, event: MatCheckboxChange) {
    this.toggleModelSelectionByValue(model, event.checked);
  }

  private toggleModelSelectionByValue(model: ProjectModel, checked: boolean) {
    if (checked) {
      this.addModel(model);
    } else {
      this.removeModel(model);
    }
  }

  private addModel(model: ProjectModel) {
    if (!this.isModelSelected(model)) {
      this.selectedModels.push(model);
    }
  }

  private removeModel(model: ProjectModel) {
    const index = this.selectedModels.findIndex(m => m.id === model.id);
    if (index !== -1) {
      this.selectedModels.splice(index, 1);
    }
  }

  isModelSelected(model: ProjectModel): boolean {
    return this.selectedModels.some(m => m.id === model.id);
  }
}


